(function () {

	const cVideo = () => {
		const video = document.querySelectorAll('.c-video > video');
		video.forEach(item => {
			const videoBox = item.closest('.c-video');
			const playBtn = videoBox.querySelector('.c-video__play');
			const playHiddenTxt = videoBox.querySelector('.c-video__play > .visually-hidden');
			playBtn.addEventListener('click', () => {
				if(item.paused) {
					item.play();
					playBtn.classList.add('c-video__play--active');
					playHiddenTxt.textContent = 'pause';
				} else {
					item.pause();
					playBtn.classList.remove('c-video__play--active');
					playHiddenTxt.textContent = 'play';
				}
			})

			item.addEventListener('play', () => {
				playBtn.classList.add('c-video__play--active');
				playHiddenTxt.textContent = 'pause';
			});

			// 일시 정지 이벤트 발생 시 클래스 제거
			item.addEventListener('pause', () => {
				playBtn.classList.remove('c-video__play--active');
				playHiddenTxt.textContent = 'play';
			});
		})
	}

	document.addEventListener('shopify:section:load', cVideo);
	cVideo();

})();